export default "__VITE_ASSET__qp41nf7V__"